var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-panel-main-frame flex-all-centered-row"},[_c('sust-sidebar',{staticStyle:{"flex":"1 !important"},attrs:{"items":_vm.navbar_items}}),_c('div',{staticClass:"router-view",class:{
            'deny-padding': _vm.deny_padding
        }},[_c('router-view',{staticStyle:{"overflow":"visible"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }